import React, { useState } from 'react'
import SectionTitle from '../../components/section_title/section_title'
import Button from '../../components/Button/Button'
import network from '../../network'
import './form.scss'

function Form() {
  const formData = {
    requirement: '',
    mail: '',
    company: '',
  }


  const formDataName = new Map([
    ['company', '公司名称'],
    ['mail', '邮箱'],
    ['requirement', '项目需求']
  ])
  const request = async () => {
    const { company: name, mail: email, requirement } = formData
    try {
      console.log(name, email, requirement)
      const res = await network('/joinUs', 'POST', {
        name,
        email,
        requirement,
      });
      console.log()
      alert('提交成功')
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const check = () => {
    const result = {
      status: true,
      message: ''
    }
    Object.keys(formData).forEach(item => {
      if (!formData[item]) {
        result.status = false
        result.message = `请填写${formDataName.get(item)}`
      }
    })

    return result
  }
  const submitForm = () => {
    const checkResult = check()
    if (checkResult.status) {
      request()
    } else {
      console.log(checkResult.message)
    }
  }
  return <div className="form-container" id="form">
    <SectionTitle type="black" subtitle="为官网升级全新的3D展销方式">申请奥本未来3D云服务试用</SectionTitle>
    <form className="form">
      <input type="text" placeholder="公司名称" onChange={e => { formData.company = e.target.value }}></input>
      <input type="email" placeholder="邮箱" onChange={e => { formData.mail = e.target.value }}></input>
      <input type="text" placeholder="项目需求" onChange={e => { formData.requirement = e.target.value }}></input>
    </form>
    <div className="banner_button">
      <Button><span onClick={() => { submitForm() }}>立即申请体验</span></Button>
    </div>
  </div>
}

export default Form